module.exports = __webpack_public_path__ + "static/img/Medical Care.4cbfc3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/Medical Care.jpg
// module id = 253g
// module chunks = 1